export enum UserPermission {
  // Audit Log
  ADD_AUDITLOG = 'add_auditlog',
  CHANGE_AUDITLOG = 'change_auditlog',
  DELETE_AUDITLOG = 'delete_auditlog',
  
  // Cabinet
  CHANGE_CABINET = 'change_cabinet',
  USE_CHATBOT = 'use_chatbot',
  USE_CHATBOT_AUDIO = 'use_chatbot_audio',
  VIEW_CABINET = 'view_cabinet',
  
  // Cabinet Proceeding
  ADD_CABINET_PROCEEDING = 'add_cabinetproceeding',
  CHANGE_CABINET_PROCEEDING = 'change_cabinetproceeding',
  DELETE_CABINET_PROCEEDING = 'delete_cabinetproceeding',
  VIEW_CABINET_PROCEEDING = 'view_cabinetproceeding',
  
  // Case
  ADD_CASE = 'add_case',
  ARCHIVE_CASE = 'archive_case',
  ASSIGN_CASE = 'assign_case',
  CHANGE_CASE = 'change_case',
  CHANGE_CASE_VISIBILITY = 'change_case_visibility',
  DELETE_CASE = 'delete_case',
  EXPORT_CASE = 'export_case',
  VIEW_CASE = 'view_case',
  VIEW_OWN_CASE = 'view_own_case',
  CHANGE_OWN_CASE = 'change_own_case',
  DELETE_OWN_CASE = 'delete_own_case',
  
  // Case Decision File
  ADD_CASE_DECISION_FILE = 'add_casedecisionfile',
  CHANGE_CASE_DECISION_FILE = 'change_casedecisionfile',
  DELETE_CASE_DECISION_FILE = 'delete_casedecisionfile',
  VIEW_CASE_DECISION_FILE = 'view_casedecisionfile',
  
  // Case Deposit
  ADD_CASE_DEPOSIT = 'add_casedeposit',
  CHANGE_CASE_DEPOSIT = 'change_casedeposit',
  DELETE_CASE_DEPOSIT = 'delete_casedeposit',
  VIEW_CASE_DEPOSIT = 'view_casedeposit',
  
  // Case File
  ADD_CASE_FILE = 'add_casefile',
  CHANGE_CASE_FILE = 'change_casefile',
  DELETE_CASE_FILE = 'delete_casefile',
  VIEW_CASE_FILE = 'view_casefile',
  
  // Case Jurisprudence
  ADD_CASE_JURISPRUDENCE = 'add_casejurisprudence',
  CHANGE_CASE_JURISPRUDENCE = 'change_casejurisprudence',
  DELETE_CASE_JURISPRUDENCE = 'delete_casejurisprudence',
  VIEW_CASE_JURISPRUDENCE = 'view_casejurisprudence',
  
  // Case Note
  ADD_CASE_NOTE = 'add_casenote',
  CHANGE_CASE_NOTE = 'change_casenote',
  DELETE_CASE_NOTE = 'delete_casenote',
  VIEW_CASE_NOTE = 'view_casenote',
  
  // Case Party
  ADD_CASE_PARTY = 'add_caseparty',
  CHANGE_CASE_PARTY = 'change_caseparty',
  DELETE_CASE_PARTY = 'delete_caseparty',
  VIEW_CASE_PARTY = 'view_caseparty',
  
  // Case Proceeding
  ADD_CASE_PROCEEDING = 'add_caseproceeding',
  CHANGE_CASE_PROCEEDING = 'change_caseproceeding',
  DELETE_CASE_PROCEEDING = 'delete_caseproceeding',
  VIEW_CASE_PROCEEDING = 'view_caseproceeding',
  
  // Case Proceeding Personal Decision
  ADD_CASE_PROCEEDING_PERSONAL_DECISION = 'add_caseproceedingpersonaldecision',
  CHANGE_CASE_PROCEEDING_PERSONAL_DECISION = 'change_caseproceedingpersonaldecision',
  DELETE_CASE_PROCEEDING_PERSONAL_DECISION = 'delete_caseproceedingpersonaldecision',
  VIEW_CASE_PROCEEDING_PERSONAL_DECISION = 'view_caseproceedingpersonaldecision',
  
  // Case Relation
  ADD_CASE_RELATION = 'add_caserelation',
  CHANGE_CASE_RELATION = 'change_caserelation',
  DELETE_CASE_RELATION = 'delete_caserelation',
  VIEW_CASE_RELATION = 'view_caserelation',
  
  // Client
  ADD_CLIENT = 'add_client',
  CHANGE_CLIENT = 'change_client',
  DELETE_CLIENT = 'delete_client',
  EXPORT_CLIENT = 'export_client',
  MERGE_CLIENT = 'merge_client',
  VIEW_CLIENT = 'view_client',
  
  // Document Template
  ADD_DOCUMENT_TEMPLATE = 'add_documenttemplate',
  CHANGE_DOCUMENT_TEMPLATE = 'change_documenttemplate',
  DELETE_DOCUMENT_TEMPLATE = 'delete_documenttemplate',
  VIEW_DOCUMENT_TEMPLATE = 'view_documenttemplate',
  
  // Generated Document
  ADD_GENERATED_DOCUMENT = 'add_generateddocument',
  CHANGE_GENERATED_DOCUMENT = 'change_generateddocument',
  DELETE_GENERATED_DOCUMENT = 'delete_generateddocument',
  VIEW_GENERATED_DOCUMENT = 'view_generateddocument',
  
  // Client Invoice
  ADD_CLIENT_INVOICE = 'add_clientinvoice',
  CHANGE_CLIENT_INVOICE = 'change_clientinvoice',
  DELETE_CLIENT_INVOICE = 'delete_clientinvoice',
  EXPORT_CLIENT_INVOICE = 'export_clientinvoice',
  SEND_CLIENT_INVOICE = 'send_clientinvoice',
  VIEW_CLIENT_INVOICE = 'view_clientinvoice',

  // Case Payment (unified — replaces CaseDeposit and ClientPayment)
  ADD_CASE_PAYMENT = 'add_casepayment',
  DELETE_CASE_PAYMENT = 'delete_casepayment',
  EXPORT_CASE_PAYMENT = 'export_casepayment',
  VIEW_CASE_PAYMENT = 'view_casepayment',

  // Cabinet Invoicing Settings
  CHANGE_CABINET_INVOICING_SETTINGS = 'change_cabinetinvoicingsettings',
  VIEW_CABINET_INVOICING_SETTINGS = 'view_cabinetinvoicingsettings',

  // Rendezvous
  ADD_RENDEZVOUS = 'add_rendezvous',
  CHANGE_RENDEZVOUS = 'change_rendezvous',
  DELETE_RENDEZVOUS = 'delete_rendezvous',
  VIEW_RENDEZVOUS = 'view_rendezvous',
  VIEW_OWN_RENDEZVOUS = 'view_own_rendezvous',
  CHANGE_OWN_RENDEZVOUS = 'change_own_rendezvous',
  DELETE_OWN_RENDEZVOUS = 'delete_own_rendezvous',
  
  // Role
  ADD_ROLE = 'add_role',
  CHANGE_ROLE = 'change_role',
  DELETE_ROLE = 'delete_role',
  VIEW_ROLE = 'view_role',
  
  // Template Request
  ADD_TEMPLATE_REQUEST = 'add_templaterequest',
  CHANGE_TEMPLATE_REQUEST = 'change_templaterequest',
  DELETE_TEMPLATE_REQUEST = 'delete_templaterequest',
  VIEW_TEMPLATE_REQUEST = 'view_templaterequest',
  
  // Todo
  ADD_TODO = 'add_todo',
  CHANGE_TODO = 'change_todo',
  DELETE_TODO = 'delete_todo',
  VIEW_TODO = 'view_todo',
  
  // User
  ADD_USER = 'add_user',
  CHANGE_USER = 'change_user',
  DELETE_USER = 'delete_user',
  MANAGE_ROLES = 'manage_roles',
  VIEW_USER = 'view_user',
  VIEW_USER_ACTIVITY = 'view_user_activity',

  // Expense
  ADD_EXPENSE = 'add_expense',
  CHANGE_EXPENSE = 'change_expense',
  DELETE_EXPENSE = 'delete_expense',
  VIEW_EXPENSE = 'view_expense',

  // Lawyer Profile
  ADD_LAWYER_PROFILE = 'add_lawyerprofile',
  CHANGE_LAWYER_PROFILE = 'change_lawyerprofile',
  DELETE_LAWYER_PROFILE = 'delete_lawyerprofile',
  VIEW_LAWYER_PROFILE = 'view_lawyerprofile',

  // Affectation
  MANAGE_AFFECTATION = 'manage_affectation',

  // External Lawyers
  MANAGE_EXTERNAL_LAWYERS = 'manage_external_lawyers',
}
